// **********************************************************
// Add/Remove/Clear Filters
// **********************************************************

const selectedItems = document.querySelectorAll('.product-filter__selected-list');
const selectedItemsParent = document.querySelectorAll('.product-filter__row--selected-items');
const allFilterInputs = document.querySelectorAll('.product-filter__list input');

const toggleFilterParent = (toggle) => {
  selectedItemsParent.forEach((item) => {
    toggleHideClass(item, toggle);
  });
};

const checkSelectedItems = () => {
  selectedItems.forEach((item) => {
    const remainingItems = item.querySelectorAll('.product-filter__selected');
    if (remainingItems.length === 0) toggleFilterParent(true);
  });
};

const removeSelectedFilter = (id) => {
  document.querySelectorAll(`[data-filter-id="${id}"]`).forEach((item) => item.remove());
  checkSelectedItems();
};

const removeSelectedFiltersByName = (name) => {
  document.querySelectorAll(`.product-filter__selected[data-filter-name="${name}"]`).forEach((btn) => btn.remove());
};

const addSelectedFilter = (label, text, id, name) => {
  selectedItems.forEach((container) => {
    if ([...container.querySelectorAll('.product-filter__selected')].some((item) => item.dataset.filterId === id)) {
      return;
    }

    const button = document.createElement('button');

    button.className = 'product-filter__selected product-filter__btn';
    button.type = 'button';

    // Safe attribute assignment
    button.dataset.filterId = id;
    button.dataset.filterName = name;

    // Icon
    const icon = document.createElement('i');
    icon.className = 'icon icon-close';

    // Text wrapper
    const textWrapper = document.createElement('span');
    textWrapper.className = 'p-none';

    // Strong label
    const strong = document.createElement('strong');
    strong.textContent = `${label}:`;

    // Safe text
    textWrapper.appendChild(strong);
    textWrapper.append(` ${text}`);

    button.appendChild(icon);
    button.appendChild(textWrapper);

    const resetWrapper = container.querySelector('.product-filter__reset-btn-wrapper');

    if (resetWrapper) {
      container.insertBefore(button, resetWrapper);
    } else {
      container.appendChild(button);
    }
  });

  toggleFilterParent(false);
};

// Uncheck Filters
const unCheckFilterInputs = (id) => {
  document.querySelectorAll(`#${id}`).forEach((input) => {
    input.checked = false;
  });
};

// Check/Uncheck Filters On Change
const applyFilterState = (input) => {
  const parent = input.closest('.product-filter__list-item');

  const inputText = input.getAttribute('data-text');
  const inputId = input.getAttribute('id');
  const inputName = input.getAttribute('name');

  // Filter label
  const labelElem = parent.querySelector('[data-filter-title]');
  const label = labelElem?.getAttribute('data-filter-title') || inputName;

  // Active size tab (EU / UK / mm / inch)
  const sizeSelector = input.closest('.size-selector');
  const activeTab = sizeSelector?.querySelector('.size-selector__nav-link.is-active');

  const activeTabText = activeTab?.textContent.trim();

  // Final text
  const finalText = activeTabText ? `${activeTabText} ${inputText}` : inputText;

  if (input.type === 'radio') {
    if (input.checked) {
      removeSelectedFiltersByName(inputName);
      addSelectedFilter(label, finalText, inputId, inputName);
    }
    return;
  }

  if (input.checked) {
    addSelectedFilter(label, finalText, inputId, inputName);
  } else {
    removeSelectedFilter(inputId);
  }
};

const triggerFilter = (input) => {
  input.addEventListener('change', () => {
    applyFilterState(input);
  });
};

// Filter
allFilterInputs.forEach((input) => {
  triggerFilter(input);
  applyFilterState(input); // With Page Load
});

// **********************************************************
// Price range pill
// **********************************************************

const priceSliderSelector = '[data-component="mol-range-slider"] .range-slider__input';

const syncPriceFilter = (el) => {
  const slider = el.noUiSlider;
  if (!slider) return;

  const [from, to] = slider.get(true);
  const { min, max } = slider.options.range;

  removeSelectedFilter('price-range');
  if (from === min && to === max) return;

  const label =
    el.closest('.product-filter__list-item')?.querySelector('[data-filter-title]')?.dataset.filterTitle || 'Price';
  const [fromText, toText] = slider.get();
  addSelectedFilter(label, `${fromText} – ${toText}`, 'price-range', 'price');
};

['rangeSlider:ready', 'rangeSlider:set'].forEach((evt) =>
  attachEvent(priceSliderSelector, evt, (ev) => syncPriceFilter(ev.target)),
);

document.querySelectorAll(priceSliderSelector).forEach(syncPriceFilter);

// Remove Selected Item
attachEvent('.product-filter__selected', 'click', (ev) => {
  const selectedEle = ev.target.closest('.product-filter__selected');
  if (!selectedEle) return;

  const inputId = selectedEle.getAttribute('data-filter-id');
  selectedEle.remove();

  unCheckFilterInputs(inputId);

  checkSelectedItems();
});

// Clear all filter
attachEvent('[data-reset-filter]', 'click', (ev) => {
  document.querySelectorAll('.filter-modal .dropdown__list-item input').forEach((item) => {
    item.checked = false;
  });
  document.querySelectorAll('.dropdown-accordion .dropdown__count').forEach((item) => {
    item.classList.add('hide');
  });

  document.querySelectorAll('.product-filter__selected').forEach((item) => {
    const inputId = item.getAttribute('data-filter-id');
    unCheckFilterInputs(inputId);
    item.remove();
  });

  checkSelectedItems();

  // Sort Reset
  document.querySelectorAll('.sort-dropdown input').forEach((input) => (input.checked = false));

  ev.preventDefault();
});

// Toggle Dropdown Into Mobile
const toggleFilterDrawer = (parent, toggle) => {
  parent.classList.toggle('is-open-filter', toggle);
};

// Close Dropdown
attachEvent('[data-close-filter]', 'click', (ev) => {
  const parentEle = ev.target.closest('[data-filter-parent]');
  const isOpen = parentEle.classList.contains('is-open-filter');
  toggleFilterDrawer(parentEle, !isOpen);
});

// Toggle filter
attachEvent('[data-filter-modal-trigger]', 'click', (ev) => {
  const parentEle = ev.target.closest('[data-filter-parent]');
  const isOpen = parentEle.classList.contains('is-open-filter');
  toggleFilterDrawer(parentEle, !isOpen);
});

window.addEventListener(
  'resize',
  debounce(() => {
    if (windowWidth() > breakpointMd) return;
    document.querySelectorAll('[data-filter-parent].is-open-filter').forEach((parent) => {
      toggleFilterDrawer(parent, false);
    });
  }, 150),
);

// Accordion: slide-toggle filter groups
document
  .querySelectorAll('.product-filter__list-item.is-open .product-filter__list-item-content')
  .forEach((content) => {
    content.style.display = 'block';
  });

attachEvent('.product-filter__list-item-title', 'click', (ev) => {
  const item = ev.target.closest('.product-filter__list-item');
  const content = item?.querySelector('.product-filter__list-item-content');
  if (!content) return;

  item.classList.toggle('is-open');
  slideToggle(content, 300, 'block');
});
